import * as ng from 'angular';

function colspanDirectiveLink(scope:ng.IScope, element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
   let val = scope.$eval(attrs.nvColspan);
   if (val > 0) {
      element.prop('colspan', val);
   }
}

ng.module('e360').directive('nvColspan', function() {
   return {
      restrict: 'A',
      link: colspanDirectiveLink
   };
});
